/**
 * ============================================================================
 * EXPERIMENT: Calendly Integration (ab_calendly)
 * PR: #TODO_AFTER_PR_CREATION_ab_calendly
 *
 * Hook to check Amplitude experiment flag for Calendly.
 * Temporary code — will be REMOVED when the experiment concludes.
 *
 * Find all experiment code: grep -r "ab_calendly" src/
 * ============================================================================
 */

import { useExperimentVariation } from '../../shared/analytics/amplitude-hooks';

export function useIsCalendlyEnabled(): boolean {
    const variant = useExperimentVariation('ab_calendly');
    return variant?.value === 'on';
}
